import { MutationOptions, useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { CommunicationType, CommunicationTypeEnum } from '@/models'

interface DeleteAnnouncementRequest {
  id: number
  type: CommunicationType
}

export const deleteAnnouncement = async ({ id, type }: DeleteAnnouncementRequest) => {
  if (type === CommunicationTypeEnum.enum.Email) {
    const response = await authAPI.delete(`/communication/scheduled/mail/${id}`)
    return response.data
  }

  const response = await authAPI.delete(`/communication/scheduled/notification/${id}`)
  return response.data
}

type UseDeleteAnnouncementOptions = Pick<
  MutationOptions<void, Error, DeleteAnnouncementRequest>,
  'onSuccess' | 'onError'
>

export const useDeleteAnnouncement = (options?: UseDeleteAnnouncementOptions) => {
  return useMutation({
    mutationFn: deleteAnnouncement,
    ...options,
  })
}
